import clsx from 'clsx';
import { Pill } from '../../../../../shared/ui/pill';
import pillStyles from '../../../../../shared/ui/pill/Pill.module.css';
import { MetaRow } from '../../../../../shared/ui/meta-row';
import { OverflowPills } from '../../../../../shared/ui/overflow-pills';
import { TruncatedText } from '../../../../../shared/ui/truncated-text';
import { formatTemplateTypeLabel } from '../lib/formatTemplateTypeLabel';
import { TEMPLATE_TYPE } from '../../../constants/messageTemplateKeys';
import { isLiveTemplateStatus } from '../../../lib/isLiveTemplateStatus';
import styles from '../TemplateCard.module.css';

export function TemplateCardFooter({ type, trigger, status, campaigns }) {
  const typeLabel = formatTemplateTypeLabel(type);
  const isTriggerType = type === TEMPLATE_TYPE.TRIGGER;
  const triggerName = trigger?.name ?? null;
  const isLiveStatus = isLiveTemplateStatus(status);

  return (
    <div className={clsx(styles.footer)} aria-label="Template meta">
      <MetaRow
        label="Type:"
        ariaLabel="Type"
        className={clsx(styles.metaRow)}
        labelClassName={clsx(styles.metaLabel)}
      >
        {typeLabel ? (
          <Pill variant="grey" nowrap>
            {typeLabel}
          </Pill>
        ) : null}
      </MetaRow>

      <MetaRow
        label="Campaign:"
        ariaLabel="Campaigns"
        className={clsx(styles.metaRow)}
        labelClassName={clsx(styles.metaLabel)}
      >
        {campaigns.length > 0 ? (
          <OverflowPills
            items={campaigns}
            wrapClassName={clsx(styles.footerPillsWrap)}
            className={clsx(styles.campaigns)}
            pillClassName={clsx(pillStyles.pill, pillStyles.variantGrey, pillStyles.nowrap)}
            ariaLabel="Campaigns"
            maxRows={1}
            tooltipItemTransform={(value) => value.toUpperCase()}
          />
        ) : (
          <span className={clsx(styles.metaDash)}>—</span>
        )}
      </MetaRow>

      <MetaRow
        label={isTriggerType ? 'Trigger:' : undefined}
        ariaLabel="Trigger"
        className={clsx(styles.metaRow)}
        labelClassName={clsx(styles.metaLabel)}
      >
        {isTriggerType ? (
          triggerName ? (
            <TruncatedText
              as={Pill}
              variant="grey"
              nowrap
              className={styles.triggerPill}
              truncatedClassName={styles.triggerPillTruncated}
              triggerClassName={styles.footerPillsWrap}
              tooltipProps={{ bubbleWidthPx: undefined }}
            >
              {triggerName}
            </TruncatedText>
          ) : !isLiveStatus ? (
            // Only a published/active trigger template is guaranteed to have a trigger;
            // other statuses may be saved empty, so show a dash for the missing value.
            <span className={clsx(styles.metaDash)}>—</span>
          ) : null
        ) : (
          <span className={clsx(styles.metaRowSpacer)} aria-hidden />
        )}
      </MetaRow>
    </div>
  );
}
